import { formatCurrency, parseCurrency } from '@brazilian-utils/brazilian-utils';

import { GeneralStatus } from 'enums/status';
import { FrequencyTypes } from 'enums/types';

export function handleDefaultValues({ setValue, defaultValues }) {
  const base = {
    client: {
      name: defaultValues.name,
      code: defaultValues.code,
      documentNumber: defaultValues.documentNumber,
      costumer: {
        label: defaultValues.costumer?.name,
        id: defaultValues.costumer?.id,
      },
      contractCompany: {
        label: defaultValues.contractCompany?.name,
        id: defaultValues.contractCompany?.id,
      },
      regional: {
        label: defaultValues.regional?.name,
        id: defaultValues.regional?.id,
      },
      project: {
        label: defaultValues.project?.name,
        id: defaultValues.project?.id,
      },
    },
    info: {
      startDate: defaultValues.startDate,
      routeCents: formatCurrency(defaultValues.routeCents / 100),
      excessKmCents: formatCurrency(defaultValues.excessKmCents / 100),
      dailyKm: defaultValues.dailyKm,
      monthlyKm: defaultValues.monthlyKm,
      source: defaultValues.source,
      destination: defaultValues.destination,
      maxOverdue: defaultValues.maxOverdue,
    },
  };

  setValue('active', defaultValues.status === GeneralStatus.Active);
  setValue('frequency', defaultValues.frequency);
  setValue('startDate', defaultValues.nextExecution);

  if (defaultValues.frequency === FrequencyTypes.Weekly) {
    defaultValues.weekDays.forEach((day) => setValue(`day.${day}`, true));
  }
  Object.entries(base).forEach(([key, value]) => Object.entries(value).forEach(([field, data]) => setValue(`${key}.${field}`, data)));
}

export function parseFormData(data) {
  const params = {
    ...data.client,
    ...data.info,
    frequency: data.frequency,
    excessKmCents: (parseCurrency(data.info.excessKmCents) * 100).toFixed(0),
    routeCents: (parseCurrency(data.info.routeCents) * 100).toFixed(0),

  };

  params.status = GeneralStatus[data.active ? 'Active' : 'Inactive'];

  if (data.frequency === FrequencyTypes.Weekly) {
    params.weekDays = Object.values(data.day).map(
      (day, index) => day && index).filter((day) => Number.isSafeInteger(day),
    );
  }

  return params;
}
